import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";
import { handleRetriveError } from "../utils";


interface warehouseState {
    results: any[];
    warehouseLoaded: boolean;
}

const initialState: warehouseState = {
    results: [],
    warehouseLoaded: false,
};


const warehouseSlice = createSlice({
    name: "warehouse",
    initialState,
    reducers: {
        setWarehouse(state, action) {
            state.results = action.payload;
        },
    },
});


export const { setWarehouse } = warehouseSlice.actions;


export const fetchWarehouse = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getWarehouses();
        dispatch(setWarehouse(response));
    } catch (error) {
        handleRetriveError(error);
    }
};

export default warehouseSlice.reducer;
